'use strict';

angular.module('paizacloudApp')
  .directive('wmtab', function($timeout, $sce) {
    return {
      // templateUrl: 'app/wmtab.directive/wmtab.directive.html',
      restrict: 'EA',
      require: '^?sidebar',
      // replace: true,
      // transclude: true,
      /*
      scope: {
        title: '@',
        onClose: '&',
        onFocus: '&',
        open: '=',

        ngModel: '=',
        container: '=',
        application: '=',

        controller: '=',

        active: '=',
      },*/
      link: function(scope, element, attrs, ctrl:any) {
        console.log("wmtab link");

        function getWbrHtmlTitle(title){
          if(!title){
            return $sce.trustAsHtml('');
          }
          const html = title.split('/').join('/<wbr>');
          const trustedHtml = $sce.trustAsHtml(html);
          return trustedHtml;
        }

        scope.viewCtrl = {hoge: 'fuga'};
        scope.title = scope.windowModel.title && (scope.windowModel.title.shortText || scope.windowModel.title.text || scope.windowModel.title);
        scope.wbrHtmlTitle = getWbrHtmlTitle(scope.title && (scope.title.text || scope.title));

        scope.controller = scope.windowModel.ctrl;
        if(scope.controller){
          scope.controller.onbeforeunload = () => {
            if(scope.viewCtrl.onbeforeunload){
              return scope.viewCtrl.onbeforeunload();
            }
          };
          scope.controller.close = (fDelete) => {
            if(scope.viewCtrl.close){
              return scope.viewCtrl.close(fDelete);
            }
          };
          scope.controller.focus = () => {
            // element.focus();
            scope.$broadcast('focus', null);
          };
          scope.controller.getSelected = () => {
            if(scope.viewCtrl.getSelected){
              return scope.viewCtrl.getSelected();
            }
          };
          scope.controller.getBodyController = () => {
            return scope.viewCtrl;
          };
        }

        /*
        scope.deleteWindow = function(){
          scope.onClose();
        };
        */
        scope.$on('title', function(event, title){
          console.log("title, windowModel:", title, scope.windowModel);
          scope.title = title.shortText || title.text || title;
          scope.windowModel.title = title;
          scope.wbrHtmlTitle = getWbrHtmlTitle(title.text || title);
        });

        scope.$on('application:close', (event) => {
          scope.$parent.close(scope.windowModel);
        });

        let resizing = false;
        scope.$on('resize view', function(event){
          if(resizing){
            return;
          }
          resizing = true;
          console.log("resize view", event);
          scope.$broadcast('resize');
          resizing = false;
        });

        scope.selectWindow = function(ev){
          scope.$broadcast('focus', ev);
          // scope.$parent.$parent.$parent.activeController = scope.viewCtrl;
          // if(ctrl) {
          //   ctrl.scope.activeController = scope.viewCtrl;
          // }
        };
        scope.$watch('container.activeWindow', function(pre, post){
          if(scope.container.activeWindow === scope.windowModel){
            $timeout(function(){
              console.log("wmtab:sending focus");
              scope.$broadcast('focus', null);
            }, 0);
          }
        });
        scope.$on('viewlinked', function(){
          console.log("wmtab on viewlinked");
          if(scope.container.activeWindow === scope.windowModel){
            console.log("wmtab:sending focus2");
            scope.$broadcast('focus', null);
          }
        });
      },
    };
  });
